import {Component, input} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {DirectusTooltipComponent} from '../../../../../../../shared/components/directus-tooltip/directus-tooltip.component';

@Component({
  selector: 'app-demonstration-summary',
  imports: [TranslocoDirective, DirectusTooltipComponent],
  templateUrl: './demonstration-summary.component.html',
})
export class DemonstrationSummaryComponent {
  totalUseCases = input.required<number>();
  includedUseCases = input.required<number>();
  plannedDuration = input.required<number>();
  actualDuration = input.required<number>();
  durationDifference = input.required<number>();

  protected formatDuration(minutes: number): string {
    return `${minutes} min`;
  }
}
